import { defaultTheme } from '../styles/theme/default';
import {
  Colors,
  ColorTokenType,
  ColorWeightType,
  PrimitiveColorsType,
  SimpleColorType,
} from '../interfaces/colors';

export const getColorHelper = (
  fillColor: PrimitiveColorsType | Colors | string,
  colorWeight?: ColorWeightType | SimpleColorType
) => {
  return colorWeight
    ? defaultTheme.colors[fillColor as PrimitiveColorsType][colorWeight]
    : defaultTheme.colorToken[fillColor as ColorTokenType] || fillColor;
};
